import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ListOverlayLoaderComponent extends Vue {
  @Prop() active!: boolean
}